import { routes } from '../routes/routes';

/**
 * ERPPDV-2483: telas que o usuário externo do cliente pode abrir — a lista e o detalhe dos álbuns
 * de fotos. A criação do álbum (`/new`) fica de fora: o cliente só consulta.
 *
 * O backend é quem barra de fato (responde 403 fora dessas rotas); isto só evita que o cliente
 * caia numa tela interna quebrada ao digitar a URL.
 */
export const CUSTOMER_USER_HOME = routes.photoAlbumList;

const ALLOWED_URL = /^\/attendances\/photo-albums(\/(?!new(?:[/?#]|$))[^/?#]+)?\/?([?#].*)?$/;

export function isCustomerUserAllowedUrl(url: string): boolean {
  return ALLOWED_URL.test(url);
}
